import styled from 'styled-components';
import { screenXsMin } from '@spotify-internal/encore-foundation';
import { ButtonPrimary, FormInput, Banner } from '@spotify-internal/encore-web';
export const Button = styled(ButtonPrimary) `
  margin: 50px 0 0 0;
  width: 100%;

  @media (min-width: ${screenXsMin}) {
    width: auto;
  }
`;
export const Input = styled(FormInput) `
  box-sizing: border-box;
`;
export const Error = styled(Banner) `
  margin-top: 20px;
`;
//# sourceMappingURL=components.js.map